import Store from '@/store';

import FeatureFlagUtil from '@/utilities/feature-flag-util';
import RouteNames from '../constants/route-names';
import RouteMeta from '../constants/route-meta';

const getHydrationErrorRoute = async (to, error) => {
  const userIsAuthenticated = Store.state.Auth.user && Store.state.Auth.user.access_token;
  const routeRequiresAuthentication = to.meta[RouteMeta.RequiresAuthentication];
  const unauthenticatedStatus = 401;
  const notFoundStatus = 404;

  if (error.status === notFoundStatus) {
    return RouteNames.CompanyNotFound;
  }

  if (error.status === unauthenticatedStatus) {
    if (userIsAuthenticated) {
      await Store.dispatch('Auth/resetUser');
    }
    if (routeRequiresAuthentication) {
      return RouteNames.AppointmentCreateAccount;
    }
  }
  return null;
};

const handleInitialRedirect = (to, next) => {
  const regex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/i;
  const routeId = to.params.companyId;
  const storeCompanyId = Store.state.Company.company.companyId;

  const redirectRoute = (to.name === RouteNames.Appointment
    ? RouteNames.AppointmentSchedule
    : null);

  if (!routeId.match(regex)) {
    next({
      name: redirectRoute || to.name,
      params: { ...to.params, companyId: storeCompanyId },
    });
  } else if (redirectRoute) {
    next({ name: redirectRoute || to.name, params: to.params });
  } else {
    next({ params: { ...to.params, companyId: storeCompanyId } });
  }
};

const hydrateCompany = async companyId => {
  await Store.dispatch('Company/initialHydration', companyId);
};

const hydrateServices = async () => {
  if (!FeatureFlagUtil.isServicesEnabled()) {
    return;
  }
  const companyId = Store.getters['Company/companyUuid'];
  await Store.dispatch('Services/loadServices', companyId);
};

const validatePersistedState = async companyIdParam => {
  const companyRecord = Store.state.Company.company;

  if (companyRecord
    && (companyRecord.id === Number.parseInt(companyIdParam, 10)
      || companyRecord.companyId === companyIdParam)) {
    return;
  }

  await Store.dispatch('resetPersistedState');
};

const validateAndHydrate = async companyId => {
  // validate Persisted State
  await validatePersistedState(companyId);

  // hydrate Company and Features
  await hydrateCompany(companyId);

  // hydrate Services
  await hydrateServices();

  // load User
  await Store.dispatch('Auth/getPerson');
};

export default {
  getHydrationErrorRoute,
  handleInitialRedirect,
  hydrateServices,
  hydrateCompany,
  validatePersistedState,
  validateAndHydrate,
};
